import Image from "next/image";
import type React from "react";
import type { EntityT } from "@/features/EntityShow/types";
import styles from "./styles.module.css";

type EntityShowT = {
	entity: EntityT;
};

export const ImgMobileEntity: React.FC<EntityShowT> = ({ entity }) => {
	return (
		<div>
			{entity.images.length ? (
				<Image
					alt={entity.name}
					width={173}
					height={119}
					src={`${entity.images[0]["original_path"]}`}
					className={styles.img}
				/>
			) : (
				<Image
					alt={"без фото"}
					width={173}
					height={119}
					src={`/imgs/no-photo.png`}
					className={styles.img}
				/>
			)}
		</div>
	);
};
